<template>
  <div class="text-center p-4">
    <img src="@/assets/business-license.jpg" alt="营业执照" style="max-width: 100%; height: auto;" />
  </div>
</template>

